import React from "react";
import { Typography } from "@mui/material";

function Settings() {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4" color={"white"}>
        Some settings page coming soon...
      </Typography>
    </React.Fragment>
  );
}

export default Settings;
